import React, { lazy, Suspense } from "react";
import HeroNavbar from "./HeroNavbar.jsx";
import { Header15 } from "./Header15";

// Lazy-load below-the-fold components so relume-ui, framer-motion and gsap
// only download after the hero is visible. This keeps the initial bundle
// to just React + the hero, improving FCP and LCP.
const Stats13 = lazy(() => import("./Stats13.jsx").then(m => ({ default: m.Stats13 })));
const Layout396 = lazy(() => import("./Layout396.jsx").then(m => ({ default: m.Layout396 })));
const Layout491 = lazy(() => import("./Layout491.jsx").then(m => ({ default: m.Layout491 })));
const Layout350 = lazy(() => import("./Layout350.jsx").then(m => ({ default: m.Layout350 })));
const Layout513 = lazy(() => import("./Layout513.jsx").then(m => ({ default: m.Layout513 })));
const Faq1 = lazy(() => import("./Faq1.jsx").then(m => ({ default: m.Faq1 })));
const Testimonial22 = lazy(() => import("./Testimonial22.jsx").then(m => ({ default: m.Testimonial22 })));
const Logo6 = lazy(() => import("./Logo6.jsx").then(m => ({ default: m.Logo6 })));
const Cta25 = lazy(() => import("./Cta25.jsx").then(m => ({ default: m.Cta25 })));
const SiteFooter = lazy(() => import("./SiteFooter.jsx").then(m => ({ default: m.default })));

function SectionLoader() {
  return <div style={{ minHeight: '200px' }} />;
}

export default function Page() {
  return (
    <>
      <div className="relume-page">
        <HeroNavbar />
        <main>
          <Header15 />
          <Suspense fallback={<SectionLoader />}>
            <Stats13 />
            <Layout396 />
            <Layout491 />
            <Layout350 />
            <Layout513 />
            <Faq1 />
            <Testimonial22 />
            <Logo6 />
            <Cta25 />
          </Suspense>
        </main>
      </div>
      <Suspense fallback={<SectionLoader />}>
        <SiteFooter />
      </Suspense>
    </>
  );
}
